export { default } from "./DetailBody";
export * from "./DetailBody";
